import {
	FlexButton,
	MimaText,
	Modal,
	MimaInput,
	MimaButton,
} from '../../components';
import { BuyAirtimeContainer, BuyDataContainer } from '../../containers';
import React, { useState } from 'react';

function AirtimeOne({
	closeModal,
	buyAirtimeContent,
	buyDataContent,
	buydata,
	buyAirtime,
	mainContent,
	goBack,
	setPinContent,
	pinContent,
	setShowSurvey,
}) {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			{mainContent && (
				<>
					<MimaText variant="subtitle">Airtime</MimaText>
					<FlexButton title="Airtime" mt={4} onClick={buyAirtime} />
				</>
				// <>
				// 	<MimaText variant="subtitle">Airtime/Data</MimaText>
				// 	<FlexButton title="Airtime" mt={4} onClick={buyAirtime} />
				// 	<FlexButton title="Data" mt={3} onClick={buydata} />
				// </>
			)}

			{buyAirtimeContent && (
				<BuyAirtimeContainer
					closeModal={closeModal}
					pinContent={pinContent}
					setPinContent={setPinContent}
					setShowSurvey={setShowSurvey}
				/>
			)}

			{/* {buyDataContent && <BuyDataContainer closeModal={closeModal} setShowSurvey={setShowSurvey}/>} */}
		</Modal>
	);
}

export default AirtimeOne;
